// extracted by mini-css-extract-plugin
module.exports = {"responsiveVideo":"ResponsiveVideo_responsiveVideo__1Msz-","videoWrapper":"ResponsiveVideo_videoWrapper__h-XBA","video":"ResponsiveVideo_video__d6Xlk"};